module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ji84B"))).then(() => parcelRequire('d0iPb'));